import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    baseUrl,
    baseUrlPropertydemat,
    baseUrl28,
    baseUrlCyperts
} from "../BaseUrl/baseurl";
import http from "../BaseUrl/baseurl";
import axios from "axios";
import { Support } from "@mui/icons-material";

const token = localStorage.getItem("token");

export const getInvestorDashboardData = createAsyncThunk(
    "getInvestorDashboardData",
    async () => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/auth/AdminDashBoardData`
            );
        } catch (error) {
            // console.log("getPropegetInvestorDashboardDatartyList", error);
            return {};
        }
        // console.log("I am response from InvestorDashboardData ", response.data);
        return response.data;
    }
);

export const getDashboardInvestmentDetails = createAsyncThunk(
    "getDashboardInvestmentDetails",
    async ({ userId }) => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlCyperts}/invest/getAdminInvestment/${userId}`
            );
        } catch (error) {
            // console.log("getRefundDhashboardData", error);
            return {};
        }
        // console.log("closedPoolDetails", response.data.data);
        return response.data.data;
    }
);

export const getCurrentPools = createAsyncThunk(
    "getCurrentPools",
    async filterData => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getallpooldata?status=${filterData}`
            );
        } catch (error) {
            // console.log("getPropertyList", error);
            return [];
        }
        // console.log("I am response from property list", response.data.data);
        return response.data.data;
    }
);

export const getNotificationList = createAsyncThunk(
    "getNotificationList",
    async () => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/notification/getallNotificationByAdmin/1`
            );
        } catch (error) {
            // console.log("getNotificationList", error);
            return [];
        }
        // console.log("I am response getNotificationList", response.data);
        return response.data.data;
    }
);

export const getClosedPools = createAsyncThunk("getClosedPools", async () => {
    let response;
    try {
        response = await axios.get(`${baseUrlPropertydemat}/pool/closePool`);
    } catch (error) {
        // console.log("getClosedPools", error);
        return [];
    }
    // console.log("I am response getClosedPools", response.data);
    return response.data.data;
});

export const getPoolDetails = createAsyncThunk(
    "getPoolDetails",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getpooldetails/${id}`
            );
        } catch (error) {
            // console.log("getPoolDetails", error);
            return [];
        }
        // console.log("I am response from Pool Details", response.data.data);
        return response.data.data;
    }
);

export const getPoolManagmentData = createAsyncThunk(
    "getPoolManagmentData",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getpoolinvestData/${id}`
            );
        } catch (error) {
            // console.log("getPoolManagmentData", error);
            return [];
        }
        // console.log(" response getPoolManagmentData", response.data);
        return response.data;
    }
);

export const getInvestorInPool = createAsyncThunk(
    "getInvestorInPool",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getPoolWiseInvestmentData/${id}`
            );
        } catch (error) {
            // console.log("getInvestorInPool", error);
            return [];
        }
        // console.log(" response getInvestorInPool", response.data);
        return response.data.data;
    }
);

export const getInvestorSupportRequest = createAsyncThunk(
    "getInvestorSupportRequest",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getAllSupportData`
            );
        } catch (error) {
            // console.log("Investor SupportRequest", error);
            return [];
        }
        // console.log("I am response from Pool Details", response);
        return response.data.data;
    }
);

export const resolveSupportRequest = createAsyncThunk(
    "resolveSupportRequest",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/resolvedSupport/${id}`
            );
        } catch (error) {
            // console.log("resolve SupportRequest", error);
            return [];
        }
        // console.log("resolve SupportRequest", response);
        return response.data;
    }
);

export const getInvestorEnquiryRequest = createAsyncThunk(
    "getInvestorEnquiryRequest",

    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getAllEnquiryData`
            );
        } catch (error) {
            // console.log("Investor SupportRequest", error);
            return [];
        }
        // console.log("I am response from Pool Details", response);
        return response.data.data;
    }
);

export const getAllInvestor = createAsyncThunk(
    "getAllInvestor",
    async filterData => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/profile/allInvestors?status=${filterData}`
            );
        } catch (error) {
            // console.log("getAllInvestor", error);
            return [];
        }
        // console.log("getAllInvestor", response);
        return response.data.data;
    }
);

export const getInvestorDetails = createAsyncThunk(
    "getInvestorDetails",
    async id => {
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/invest/getUserInvestmentData/${id}`
            );
        } catch (error) {
            console.log("getInvestorDetails", error);
            return [];
        }
        // console.log("getInvestorDetails", response.data);
        return response.data;
    }
);

export const storeTransactionHash = createAsyncThunk(
    "storeTransactionHash",

    async data => {
        let response;
        try {
            response = await axios(
                `${baseUrlPropertydemat}/pool/storePoolTransacationHash`,
                data
            );
        } catch (error) {
            // console.log("storeTransactionHash", error);
        }
        // console.log("storeTransactionHash", response);
        return response.data;
    }
);

export const storePennyTransactionHash = createAsyncThunk(
    "storePennyTransactionHash",

    async data => {
        let response;
        try {
            response = await fetch(
                `${baseUrlPropertydemat}/profile/storeUserpennyTransactionHash`,
                data
            );
        } catch (error) {
            // console.log("storePennyTransactionHash", error);
        }
        // console.log("storePennyTransactionHash", response);
        return response.data;
    }
);

export const filterPennyTransaction = createAsyncThunk(
    "filterPennyTransaction",

    async data => {
        let response;
        try {
            response = await fetch(
                `${baseUrlPropertydemat}/penny/getalluserpennytransacation/?stardDate=2024-11-23T09:47:55.747Z& =2025-01-23T09:47:55.747Z `,
                data
            );
        } catch (error) {
            // console.log("filterPennyTransaction", error);
        }
        // console.log("filterPennyTransaction", response);
        return response.data;
    }
);

export const getRefundUserList = createAsyncThunk(
    "getRefundUserList",
    async ({ poolID, refundAmount }) => {
        // console.log("RefundUserList param", poolID, refundAmount);
        let response;
        try {
            response = await axios.get(
                `${baseUrlPropertydemat}/pool/getUserSurplusAmontList/${poolID}/${refundAmount}`
            );
        } catch (error) {
            // console.log("getRefundUserList", error);
        }
        // console.log("getRefundUserList", response.data);
        return response.data.data;
    }
);

const InvestorySlice = createSlice({
    name: "Investory",

    initialState: {
        InvestorDashboardData: {},
        InvestmentRefundDashboardData: [],
        CurrentPoolList: [],
        ClosedPoolList: [],
        PoolDetails: {},
        PoolManagementData: {},
        SupportRequest: [],
        EnquiryRequest: [],
        SupportRequestResolveStatus: {},
        AllInvestorList: [],
        PoolInvestorList: {},
        InvestorDetails: {},
        RefundUserList: [],
        NotificationList: []
    },

    extraReducers(builder) {
        builder
            .addCase(getCurrentPools.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getCurrentPools.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.CurrentPoolList = action.payload;
            })
            .addCase(getCurrentPools.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getDashboardInvestmentDetails.pending, (state, action) => {
                state.stutus = "loading";
            })
            .addCase(
                getDashboardInvestmentDetails.fulfilled,
                (state, action) => {
                    state.status = "succeeded";
                    state.InvestmentRefundDashboardData = action.payload;
                }
            )
            .addCase(
                getDashboardInvestmentDetails.rejected,
                (state, action) => {
                    state.stutus = "failed";
                    state.error = action.error.message;
                }
            );

        builder
            .addCase(getInvestorDashboardData.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorDashboardData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.InvestorDashboardData = action.payload;
            })
            .addCase(getInvestorDashboardData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getNotificationList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getNotificationList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.NotificationList = action.payload;
            })
            .addCase(getNotificationList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getClosedPools.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getClosedPools.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.ClosedPoolList = action.payload;
            })
            .addCase(getClosedPools.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getPoolDetails.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPoolDetails.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PoolDetails = action.payload;
            })
            .addCase(getPoolDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getPoolManagmentData.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getPoolManagmentData.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PoolManagementData = action.payload;
            })
            .addCase(getPoolManagmentData.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getInvestorInPool.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorInPool.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.PoolInvestorList = action.payload;
            })
            .addCase(getInvestorInPool.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getInvestorSupportRequest.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorSupportRequest.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.SupportRequest = action.payload;
            })
            .addCase(getInvestorSupportRequest.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(resolveSupportRequest.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(resolveSupportRequest.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.SupportRequestResolveStatus = action.payload;
            })
            .addCase(resolveSupportRequest.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getAllInvestor.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getAllInvestor.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.AllInvestorList = action.payload;
            })
            .addCase(getAllInvestor.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getInvestorDetails.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorDetails.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.InvestorDetails = action.payload;
            })
            .addCase(getInvestorDetails.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getInvestorEnquiryRequest.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getInvestorEnquiryRequest.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.EnquiryRequest = action.payload;
            })
            .addCase(getInvestorEnquiryRequest.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });

        builder
            .addCase(getRefundUserList.pending, (state, action) => {
                state.status = "loading";
            })
            .addCase(getRefundUserList.fulfilled, (state, action) => {
                state.status = "succeeded";
                state.RefundUserList = action.payload;
            })
            .addCase(getRefundUserList.rejected, (state, action) => {
                state.status = "failed";
                state.error = action.error.message;
            });
    }
});

export default InvestorySlice.reducer;
